export enum Keyword {
  Anime = '210024',
  Nature = '221355',
}
